enum UserRole {
  ROLE_SUPER_USER = 'ROLE_SUPER_USER',
  ROLE_ACCOUNT_MANAGER = 'ROLE_ACCOUNT_MANAGER',
  ROLE_CLIENT = 'ROLE_CLIENT',
}

export default UserRole;
